export var MitoGaugeStatus;
(function (MitoGaugeStatus) {
    MitoGaugeStatus["Active"] = "active";
    MitoGaugeStatus["Live"] = "live";
})(MitoGaugeStatus || (MitoGaugeStatus = {}));
